import UserService from "./services/UserService";

const RenderOnLogin = ({ children }) => (UserService?.isLoggedIn()) ? children : UserService?.doLogin();

export default RenderOnLogin
